import { render, staticRenderFns } from "./Edit_Allocation.vue?vue&type=template&id=25c5f32f&"
import script from "./Edit_Allocation.vue?vue&type=script&lang=js&"
export * from "./Edit_Allocation.vue?vue&type=script&lang=js&"
import style0 from "./Edit_Allocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports